import { useCallback, useState } from 'react';

export interface Queue<T> {
  prepend: (item: T) => void;
  append: (item: T) => void;
  remove: (item: T) => void;
  current: T;
  items: T[];
}

export function useQueue<T>(initialQueue = []): Queue<T> {
  const [items, setItems] = useState<T[]>(initialQueue);

  const append = useCallback((item: T) => {
    setItems(prevQueue => [...prevQueue, item]);
  }, []);

  const prepend = useCallback((item: T) => {
    setItems(prevQueue => [item, ...prevQueue]);
  }, []);

  const remove = useCallback((item: T) => {
    setItems(prevQueue => prevQueue.filter(i => i !== item));
  }, []);

  const current = items[0];

  return {
    append,
    prepend,
    remove,
    current,
    items,
  };
}
